export enum AlertType {
  Alarm = 'alarm',
  Warning = 'warning',
  Caution = 'caution',
  Running = 'running',
  Notification = 'notification',
}

export enum Direction {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
}
